import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from './assets/no-data.png'


const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sv-el-table-empty" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", null, "No Data")
], -1)
const _hoisted_3 = {
  key: 0,
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sv_ellipsis = _resolveComponent("sv-ellipsis")!
  const _component_el_table_v2 = _resolveComponent("el-table-v2")!
  const _component_el_auto_resizer = _resolveComponent("el-auto-resizer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_ctx.rendered)
    ? (_openBlock(), _createBlock(_component_el_auto_resizer, {
        key: 0,
        "on-resize": _ctx.handleResize
      }, {
        default: _withCtx(({ height, width }) => [
          _withDirectives((_openBlock(), _createBlock(_component_el_table_v2, _mergeProps({
            class: ["sv-el-table-v2", {'is-computing': _ctx.isComputing }],
            ref: "tableRef",
            columns: _ctx.tableColumns,
            data: _ctx.tableData,
            width: width,
            height: height,
            fixed: ""
          }, _ctx.$attrs), {
            empty: _withCtx(() => [
              _withDirectives(_createElementVNode("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "empty", {}, () => [
                  _hoisted_2
                ])
              ], 512), [
                [_vShow, !_ctx.loading]
              ])
            ]),
            cell: _withCtx(({ column, columnIndex, rowData, rowIndex }) => [
              _renderSlot(_ctx.$slots, column.slot, {
                column: column,
                columnIndex: columnIndex,
                row: rowData,
                index: rowIndex
              }, () => [
                (column.ellipsis)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_sv_ellipsis, {
                        content: rowData[column.dataKey],
                        placement: column.placement || 'bottom'
                      }, null, 8, ["content", "placement"])
                    ]))
                  : (column.type !== 'operation' && column.type !== 'tableSet' && column.dataKey)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (column.dataKey && (rowData[column.dataKey] || rowData[column.dataKey] === 0))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(rowData[column.dataKey]), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("-")
                            ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [], 64))
              ])
            ]),
            _: 2
          }, 1040, ["class", "columns", "data", "width", "height"])), [
            [_directive_loading, { loading: _ctx.loading, showText: true }]
          ])
        ]),
        _: 3
      }, 8, ["on-resize"]))
    : _createCommentVNode("", true)
}